export const HR_ADMIN_ROLES = ["HR", "Super Admin", "Manager"];
export const HR_ONLY_ROLES = ["HR", "Employee"];

export function getAuthRole() {
  return localStorage.getItem("userRole") || "";
}

export function isHrAdminRole(role = getAuthRole()) {
  return HR_ADMIN_ROLES.includes(role);
}

export function canOpenHrPages(role = getAuthRole()) {
  return isHrAdminRole(role);
}

export function isHrIsolatedRole(role = getAuthRole()) {
  return role === "HR";
}

export function hrHomePath(role = getAuthRole()) {
  if (role === "HR") return "/hr";
  if (role === "Employee") return "/profile";
  return "/dashboard";
}

export const FIELD_TEAM_ROLES = ["FE-Property"];

export const CRM_ROLE_ORG = {
  "Super Admin": { department: "Leadership", designation: "Super Admin" },
  Manager: { department: "Management", designation: "Manager" },
  "FE-Property": { department: "Field", designation: "FE-Property" },
  "BO-Client": { department: "CRM", designation: "BO-Client" },
  "BO-Lead": { department: "Lead", designation: "BO-Lead" },
  "Lead-Employee": { department: "Lead", designation: "Lead-Employee" },
  "Product-Manager": { department: "Product", designation: "Product-Manager" },
  HR: { department: "HR", designation: "HR" },
  Employee: { department: "Operations", designation: "Employee" },
};

export function orgFromCrmRole(role) {
  const found = CRM_ROLE_ORG[role];
  if (found) return { department: found.department, designation: found.designation };
  return { department: "", designation: role || "" };
}

export const HR_ASSIGNABLE_ROLES = [
  "Manager",
  "FE-Property",
  "BO-Client",
  "BO-Lead",
  "Lead-Employee",
  "Product-Manager",
  "HR",
  "Employee",
];

/** Roles HR may assign, inactivate, or create a login for. Super Admin is unrestricted. */
export const HR_OPERATED_ROLES = ["FE-Property", "Lead-Employee", "Employee", "HR"];

export function assignableHrRoles(role = getAuthRole()) {
  if (role === "Super Admin") return HR_ASSIGNABLE_ROLES;
  return HR_OPERATED_ROLES;
}

export function canHrDeactivateRole(actorRole, targetRole) {
  if (actorRole === "Super Admin") return true;
  if (!targetRole) return true;
  return HR_OPERATED_ROLES.includes(targetRole);
}

export function hrPhotoSrc(photoUrl) {
  if (!photoUrl) return "";
  const value = String(photoUrl).trim();
  if (/^https?:\/\//i.test(value)) return value;
  const api = import.meta.env.VITE_API_BASE_URL || "";
  const origin = String(api).replace(/\/api\/?$/, "");
  if (value.startsWith("/")) return `${origin}${value}`;
  return `${origin}/api/hr/photos/${value}`;
}

export const EMPLOYMENT_TYPES = ["Full-time", "Contract", "Intern", "Consultant"];

export const EMPLOYMENT_STATUSES = [
  "Candidate",
  "Selected",
  "OfferIssued",
  "OfferAccepted",
  "Onboarding",
  "Probation",
  "Active",
  "PIP",
  "Notice",
  "Inactive",
];

export const ATTENDANCE_STATUSES = ["Present", "Absent", "Late", "Half Day", "Leave", "Holiday"];
